import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrailerPoolReport extends Layout {
    excludabletextboxF: ExcludableTextbox;
    excludabletextboxLocation: ExcludableTextbox;
    excludabletextboxT: ExcludableTextbox;
    excludabletextboxTrailer: ExcludableTextbox;
    excludabletextboxZ: ExcludableTextbox;
    sourceTrailerPoolReport: DataSource;
    switchException: Switch;
    switchIncludeMove: Switch;
    textboxDeliveryDate: Textbox;
    textboxGroupBy: Textbox;
    textboxNumberOfDay: Textbox;
    textboxSortBy: Textbox;
}
